import gsap from 'gsap';
( function( app ) {
  const COMPONENT = {
    init: function() {
      if ( !window.hasMotion ) {
        $( '.van-slider-hero' ).addClass( 'js-animated' );
        return;
      }

      $( '.van-slider-hero' ).each( function( key, component ) {
        const halfPill = $( this ).find( '.van-slider-hero__half-pill' )[0];
        const image = $( this ).find( '.van-slider-hero__image' )[0];
        const height = $( this ).outerHeight();

        const tl = gsap.timeline( {
          scrollTrigger: {
            trigger: this,
            start: 'top 80%',
            scrub: 0.15,
            onEnter: ( {progress, direction, isActive} ) => {
              $( component ).addClass( 'js-animated' );
            },
            onRefresh: ( self ) => {
              if ( self.progress > 0 ) {
                $( component ).addClass( 'js-animated' );
              }
            },
            // markers: true,
          },
        } );
      } );
    },
    finalize: function() {
    },
  };

  app.registerComponent( 'van-slider-hero', COMPONENT );
} )( app );
